import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useRouter } from 'next/compat/router';

import { IncrementSpecialClicksDocument } from 'src/gql/graphql';

export function useSpecialsClickTracking(): void {
  const router = useRouter();
  const { special } = router?.query ?? {};
  const [incrementSpecialClicksMutation] = useMutation(IncrementSpecialClicksDocument);

  useEffect(() => {
    if (special && typeof special === 'string') {
      void incrementSpecialClicksMutation({ variables: { input: { _id: special } } });
    }
  }, [special, incrementSpecialClicksMutation]);
}
